/**
 * Состояние синхронизации показывается ровно то, что есть (принцип 5 «нет
 * кнопки Сохранить»). Врать «сохранено», пока правка лежит в очереди, нельзя —
 * это ровно тот случай, ради которого индикатор и заводится.
 */

export type SyncStatus =
  | { kind: 'saved' }
  | { kind: 'saving' }
  | { kind: 'offline'; pending: number }
  | { kind: 'error'; pending: number; retryInSeconds: number }
  /**
   * Сервер отказался принять правку по содержанию. Отдельное состояние, а не
   * «сохранено»: отвергнутая мутация остаётся в локальной копии и на экране,
   * так что без этого человек видит задачу, которой на сервере нет, — и узнаёт
   * об этом с другого устройства, когда её там не окажется.
   */
  | { kind: 'rejected'; count: number }
  /**
   * Сервер сказал, что сессии больше нет: отключили устройство или истёк срок.
   *
   * Отдельное состояние, потому что чинится оно единственным способом —
   * входом, — и ни один повтор его не исправит. Пока его не было, мёртвая
   * сессия показывалась как «оффлайн» и повторялась до скончания века: сервер
   * отвечает, сеть есть, а правки не уезжают и объяснения этому нет.
   */
  | { kind: 'signed-out' };

export function describeStatus(status: SyncStatus): string {
  switch (status.kind) {
    case 'saved':
      return 'сохранено';
    case 'saving':
      return 'сохраняем…';
    case 'offline':
      return `оффлайн, ${String(status.pending)} ${pluralEdits(status.pending)} ${waits(status.pending)}`;
    case 'error':
      return `ошибка, повтор через ${String(status.retryInSeconds)} с`;
    case 'rejected':
      return `${String(status.count)} ${pluralEdits(status.count)} не приняты сервером`;
    case 'signed-out':
      return 'вход отключён, войдите заново';
  }
}

/** «Одна правка ждёт», но «две правки ждут»: индикатор читают глазами каждый день. */
function waits(count: number): string {
  return count % 10 === 1 && count % 100 !== 11 ? 'ждёт' : 'ждут';
}

function pluralEdits(count: number): string {
  const tail = count % 100;
  if (tail >= 11 && tail <= 14) return 'правок';

  switch (count % 10) {
    case 1:
      return 'правка';
    case 2:
    case 3:
    case 4:
      return 'правки';
    default:
      return 'правок';
  }
}
